const authActionTypes = {
  LOGIN: "LOGIN",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  SET_USER: "SET_USER",
  LOGOUT: "LOGOUT",
};

export default authActionTypes;
